import { authClient, API } from '../index'

// Get all users
export const getUsers = (options) => {
  return authClient().get(`${API}/user?getDisabled=${options?.active ? false: true}${options?.therapists ? `&getTherapists=true` : ""}`)
}

// Get user by id
export const getUserById = (id) => {
  return authClient().get(`${API}/user/${id}`)
}

// Delete user
export const deleteUser = (id) => {
  return authClient().delete(`${API}/user/${id}`)
}

// Create user
export const postUser = async (user) => {
  return authClient().post(`${API}/user`, user)
}

// Update user
export const updateUser = async (id, user) => {
  return authClient().put(`${API}/user/${id}`, user)
}

// Count all admins
export const countAdmins = () => {
  const role = "admin"
	return authClient().get(`${API}/user/count/${role}`)
}

// Change status user
export const changeStatusUser = async (id, active) => {
	return authClient().put(`${API}/user/change-status/${id}`, { active });
};

export const changeEventsUrl = async (id, eventsUrl) => {
	return authClient().put(`${API}/user/change-events-url/${id}`, { eventsUrl });
};

export const getUserByToken = async (token) => {
  return authClient().get(`${API}/user/token/${token}`);
}

export const sendVerifyUserMailAndRefresh = async (token) => {
  return authClient().post(`${API}/user/send-verify-email-refresh/${token}`);
}
// Update therapist weekly availability
export const updateUserAvailability = async (id, availability) => {
  return authClient().put(`${API}/user/${id}/availability`, { availability });
}
